module.exports = __webpack_public_path__ + "assets/img/Type BS (1).ccac1ff5.jpg";